export const DataInfertility = [
    {
        id:1,
        image:"/Images/Maternity/Infertility/IVI Treatment Infertility Sabari Hospital.webp",
        title:"IVI Treatment",
        subTitle:"(Intravaginal insemination) A fertility treatment  involves introducing sperm into the uterus.",
    },
    {
        id:2,
        image:"/Images/Maternity/Infertility/Ovulation Induction Infertility Sabari Hospital.webp",
        title:"Ovulation Induction",
        subTitle:"A medical treatment that helps women who have trouble ovulating or releasing eggs."
    },
    {
        id:3,
        image:"/Images/Maternity/Infertility/Hormonal Assessment Infertility Sabari Hospital.webp",
        title:"Hormonal Assessment",
        subTitle:"Hormone test,measures the levels of hormones in your body."
    },
    {
        id:4,
        image:"/Images/Maternity/Infertility/Minimally Invasive Surgery Infertility Sabari Hospital.webp",
        title:"Minimally Invasive Surgery",
        subTitle:"A type of surgery that uses small incisions and specialized instruments to perform an operation."
    },
    {
        id:5 ,
        image:"/Images/Maternity/Infertility/Laparoscopic ovarian drilling (LOD) Infertility Sabari Hospital.webp",
        title:"Laparoscopic ovarian drilling (LOD)",
        subTitle:"A surgical procedure that can help with ovulation and pregnancy for women with polycystic ovary syndrome (PCOS)."
    },
    {
        id:5 ,
        image:"/Images/Maternity/Infertility/Counseling Support Infertility Sabari Hospital.webp",
        title:"Counseling and support",
        subTitle:"Emotional support and guidance in infertility."
    },
];

export const SudhaInfertility = [
    {
        id:1,
        image:"/Images/Maternity/Infertility/Ovum-Pick-Up-Sabari-Hospital-Sivaganga.webp",
        title:"Ovum pick up (OPU)",
        subTitle:"A procedure to remove eggs from the ovaries."
    },
    {
        id:2,
        image:"/Images/Maternity/Infertility/Embrayo-Transfer-Sabari-Hospital-Sivaganga.webp",
        title:"Embryo Transfer",
        subTitle:"A procedure to implant fertilized eggs into the uterus."
    },
];

